
interface AudienceDetailProps {
  title: string;
  description: string;
  image: string;
  features: string[];
}

const AudienceDetail = ({ title, description, image, features }: AudienceDetailProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div className="rounded-xl overflow-hidden shadow-lg">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover"
          style={{ maxHeight: "400px" }}
        />
      </div>
      <div>
        <h3 className="text-2xl font-bold text-abbella-ebony mb-4">{title}</h3>
        <p className="text-lg text-slate-600 mb-6">{description}</p>
        <ul className="space-y-3">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-abbella-aqua/20 flex items-center justify-center mt-1 flex-shrink-0">
                <span className="text-abbella-aqua text-xs">✓</span>
              </div>
              <span className="text-slate-700">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AudienceDetail;
